import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  label: string;
  onClick?: () => void;
  to?: string;
  className?: string;
}

const BackButton = ({ label, onClick, to, className = "" }: BackButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center text-sm text-gray-600 hover:text-gray-900 transition-colors ${className}`}
    >
      <ChevronLeft className="w-4 h-4" />
      <span className="font-medium">{label}</span>
    </button>
  );
};

export default BackButton;
